import React from 'react';
import '../TeleCalling.css';
import { Box } from '@mui/material';
import LoaderIcon from '../../../Assets/images/loader.svg';


const TcSectionLoader = ({ className = '', sx = {} }) => (
    <Box
        className={`tc-section-loader ${className}`}
        sx={sx}
    >
        <img
            src={LoaderIcon}
            alt="loading"
            className="tc-loader-spinner"
        />
    </Box>
);

export default TcSectionLoader;
